import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { recruitingStatusQuerySchema } from './recruiting-status-query-schema';

export const recruitingStatusUpdateSchema = recruitingStatusQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: statusMutationSchema });

export type RecruitingStatusUpdateSchema = z.infer<typeof recruitingStatusUpdateSchema>;

export const recruitingStatusCreateSchema = recruitingStatusUpdateSchema.pick({ name: true, status: true });
export type RecruitingStatusCreateSchema = z.infer<typeof recruitingStatusCreateSchema>;
